import { Chip, Tooltip, Typography } from '@mui/material';
import React, { useState, useMemo, useCallback, useEffect } from 'react';
import { ACTIVITY_TYPE_LABELS, handleValidateCodevalue, idWidth, nameWidth, ownerWidth, parentTaskIdWidth, statusWidth, templateSubjectWidth, whocolumnWidth } from '../../Utility/constant';
import history from '../../Utility/history';
import { privateRoutesPath } from '../../Routes';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import LoaderIcon from '../../Assets/images/loader.svg';
import { StyledDiv } from '../../Components/Styled';
import { GridActionsCellItem } from '@mui/x-data-grid';
import { useSnackbar } from 'notistack';
import NotificationDialog from '../../Components/NotificationDialog';
import { isPastDate } from '../../Utility/calculations';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';

import {
    useActionablesConfig,
    useActionablesData,
    ActionablesFilters,
    ActionablesTabs
} from '../../Components/Actionable';
import StatusChip from '../../Components/StatusChip';
import TruncatedTextCell from '../../Components/TruncatedTextCell';
import useNavigation from '../../Utility/hooks/useNavigation';
import './Dashboard.css';

const EMPTY_STATUSES= [];
const TaskActionables = ({ onRegisterRefetch, isActive = true }) => {
    const location = useLocation();
    const { enqueueSnackbar } = useSnackbar();

    const {
        ownerDropdown,
        selectedOwner,
        handleSelectOwner,
        isDropdownDisabled,
        isReady,
        ownerLabel,
        ownerlist,
        myTeam,
        internationalise
    } = useActionablesConfig({ type: 'task' });

    const {
        actionables,
        todayTableData,
        nextDaysTableData,
        filters,
        handleMarkAsRead,
        handleMarkAsReadIfUnread,
        markAsReadApi,
        handleToggleUnread,
        getRowClassName,
        refetch,
    } = useActionablesData({
        type: 'task',
        selectedOwner,
        ownerlist,
        myTeam,
        prospectStatuses: EMPTY_STATUSES,
        isActive

    });

    const [dialogState, setDialogState] = useState({ isCalendarOpen: false, notifyBox: null });

    useEffect(() => {
        if (onRegisterRefetch && refetch) {
            onRegisterRefetch(refetch);
        }
    }, [onRegisterRefetch, refetch]);

    const handleOpenNotifyBox = useCallback((row) => {
        const Owner = ownerDropdown?.find(item => item?.id === row?.ownerId);
        setDialogState(prev => ({
            ...prev,
            notifyBox: {
                row: row,
                open: true,
                destinationId: row?.taskId,
                receiverId: Owner?.id,
                ownerName: Owner?.name
            }
        }));
    }, [ownerDropdown]);

    const handleCloseNotifyBox = useCallback(() => {
        setDialogState(prev => ({
            ...prev,
            notifyBox: { message: "", open: false, ownerName: "", required: false }
        }));
    }, []);


const { openInNewTab } = useNavigation();
    const handleEditTask = useCallback((row) => {
        markAsReadApi({
            ...row,
            read: false
        });

      openInNewTab(
        `${privateRoutesPath?.EDIT_TASK}/${row?.taskId}`
      );
    }, [location.pathname, markAsReadApi]);

    const columns = useMemo(() => [
        {
            field: 'actions',
            type: 'actions',
            headerName: handleValidateCodevalue(internationalise, 'COMMON_ACTION'),
            minWidth: 100,
            getActions: (params) => {
                const isRead = params.row.read;
                return [
                    <Tooltip title={handleValidateCodevalue(internationalise, isRead ? 'DB_MARK_AS_UNREAD' : 'DB_MARK_AS_READ')}>
                        <GridActionsCellItem
                            key="mark-read"
                            icon={
                                isRead ? (
                                    <TaskAltIcon fontSize="small" className="secondary-color" />
                                ) : (
                                    <RadioButtonUncheckedIcon fontSize="small" className="secondary-color" />
                                )
                            }
                            label={handleValidateCodevalue(internationalise, isRead ? 'DB_MARK_AS_UNREAD' : 'DB_MARK_AS_READ')}
                            onClick={(e) => {
                                e.stopPropagation();
                                handleMarkAsRead(params.row);
                            }}
                            showInMenu={false}
                        />
                    </Tooltip>,
                    <Tooltip title={handleValidateCodevalue(internationalise, 'NOTIFY_TOOLTIP_TITLE')}>
                        <GridActionsCellItem
                            key="notify"
                            icon={<NotificationsOutlinedIcon fontSize="small" className="secondary-color" />}
                            label={handleValidateCodevalue(internationalise, 'NOTIFY_TOOLTIP_TITLE')}
                            onClick={(e) => {
                                e.stopPropagation();
                                handleOpenNotifyBox(params.row);
                            }}
                            showInMenu={false}
                        />
                    </Tooltip>
                ];
            }
        },
        {
            field: 'ownerId',
            headerName: handleValidateCodevalue(internationalise, 'TASK_SEARCH_OWNER'),
            flex: 1,
            editable: true,
            minWidth: ownerWidth,
            valueGetter: ({ value }) => {
                const owner = ownerDropdown.find(c => c.id === value);
                return owner ? owner.name : '';
            }
        },
        {
            field: 'taskId',
            headerName: handleValidateCodevalue(internationalise, 'TASK_SEARCH_TASK_ID'),
            flex: 1,
            minWidth: idWidth,
            editable: false,
            renderCell: (params) => {
                const { value, row } = params;
                return (
                    <span
                        onClick={()=>handleEditTask(row)}
                        className="actionable-table-clickable-id"
                    >
                        {value}
                    </span>
                );
            }
        },
        {
            field: 'parentTaskId',
            headerName: handleValidateCodevalue(internationalise, 'TASK_SEARCH_PARENT_TASK_ID'),
            flex: 1,
            minWidth: parentTaskIdWidth,
            editable: false,
            renderCell: (params) => {
                const value = params.value;
                if (!value) return null;
                return (
                    <span
                        onClick={() => openInNewTab(`${privateRoutesPath?.EDIT_TASK}/${value}`)}
                        className="actionable-table-clickable-id"
                    >
                        {value}
                    </span>
                );
            }
        },
       
        {
            field: 'description',
            headerName: handleValidateCodevalue(internationalise, 'TASK_EDIT_DESCRIPTION'),
            flex: 1,
            editable: true,
            minWidth: templateSubjectWidth,
            renderCell: (params) => <TruncatedTextCell text={params.value} dialogTitle="TASK_EDIT_DESCRIPTION" stripHtml={true} />
        },
        {
            field: 'latestNote',
            headerName: handleValidateCodevalue(internationalise, 'TASK_ACTIVITY_NOTE'),
            flex: 1,
            editable: true,
            minWidth: templateSubjectWidth,
            renderCell: (params) => (
                <TruncatedTextCell
                    text={params.value}
                    dialogTitle="TASK_ACTIVITY_NOTE"
                    stripHtml={true}
                    activityType={params.row.activityType}
                    recipients={params.row.recipients}
                    createdAt={params.row.createdAt}
                    callStatus={params.row.callStatus}
                    callDuration={params.row.callDuration}
                />
            )
        },
         {
            field: 'activityType',
            headerName: handleValidateCodevalue(internationalise, 'COMMON_DETAILS') || 'Details',
            flex: 1,
            editable: false,
            minWidth:nameWidth,
            renderCell: (params) => {
                return <span>{params.row.activityType ? ACTIVITY_TYPE_LABELS[params.row.activityType] || params.row.activityType : 'Note'}</span>;
            }
        },
        {
            field: 'customerName',
            headerName: handleValidateCodevalue(internationalise, 'TASK_SEARCH_CUSTOMER_NAME'),
            flex: 1,
            minWidth: nameWidth,
            editable: false
        },
        {
            field: 'nextFollowupDate',
            headerName: handleValidateCodevalue(internationalise, 'DB_COL_FU_DATE'),
            flex: 1,
            editable: true,
            minWidth: whocolumnWidth,
            renderCell: (params) => {
                return (
                    <Chip
                        onClick={()=>handleEditTask(params?.row)}
                        variant='outlined'
                        className={(isPastDate(params?.row?.nextFollowupDate) && params?.row?.read === false)
                            ? 'secondary-bg-color'
                            : ""
                        }
                        label={params?.row?.nextFollowupDate}
                    />
                );
            }
        },
        {
            field: 'taskStatus',
            headerName: handleValidateCodevalue(internationalise, 'TASK_SEARCH_STATUS'),
            flex: 1,
            editable: false,
            minWidth: statusWidth,
            renderCell: (params) => (
                <StatusChip
                    isLead={false}
                    systemLookup={params?.row?.systemLookUpCodeStatus}
                    status={params.row.taskStatus}
                    internationalise={internationalise}
                />
            )
        }
    ], [internationalise, ownerDropdown, handleEditTask, handleMarkAsRead, handleOpenNotifyBox]);
    
    const renderValuesOnCard = [
      { field: "taskStatus", useLabel: true,left : true,useChip : true},
      { field: "nextFollowupDate" , right : true},
      { field: "description", stripHtml: true, truncate: true },
    ];

    return (
        <StyledDiv>
            <ActionablesFilters
                internationalise={internationalise}
                ownerDropdown={ownerDropdown}
                selectedOwner={selectedOwner}
                onOwnerChange={handleSelectOwner}
                isDropdownDisabled={isDropdownDisabled}
                ownerLabel={ownerLabel}
                filters={filters}
                onToggleUnread={handleToggleUnread}
                showProspectToggle={false}
                isCalendarOpen={dialogState.isCalendarOpen}
                onOpenCalendar={() => setDialogState(prev => ({ ...prev, isCalendarOpen: true }))}
            />

            <ActionablesTabs
                isLead={false}
                handleMarkAsRead={handleMarkAsRead}
                titleField="taskId"
                handleOnClickCard={handleEditTask}
                renderValuesOnCard={renderValuesOnCard}
                internationalise={internationalise}
                columns={columns}
                todayData={todayTableData}
                nextDaysData={nextDaysTableData}
                allData={actionables}
                getRowClassName={getRowClassName}
                isCalendarOpen={dialogState.isCalendarOpen}
                onCloseCalendar={() => setDialogState(prev => ({ ...prev, isCalendarOpen: false }))}
            />

            {dialogState.notifyBox?.open && (
                <NotificationDialog
                    open={dialogState.notifyBox.open}
                    ownerName={dialogState.notifyBox.ownerName}
                    destinationType="TASK"
                    contextPayload={{
                        destinationId: dialogState.notifyBox.destinationId,
                        receiverId: dialogState.notifyBox.receiverId
                    }}
                    handleMarkAsReadIfUnread={() => handleMarkAsReadIfUnread(dialogState.notifyBox?.row)}
                    onClose={handleCloseNotifyBox}
                    enqueueSnackbar={enqueueSnackbar}
                    internationalise={internationalise}
                    handleValidateCodevalue={handleValidateCodevalue}
                />
            )}
        </StyledDiv>
    );
};

export default TaskActionables;
